import React from 'react'
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import { ReactComponent as Arrow } from "../assets/arrow.svg"

import Title from "../components/global/Title/Title"
import Content from "../components/global/Content/Content"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

export default class ANBIScreen extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      loading: false,
      error: '',
      data: [],
    }
  }

  componentDidMount() {
    this.setState({loading: true})

    axios.get(`/wp-json/wp/v2/pages/1024`)
    .then( res => {
      this.setState({ data: res.data, loading: false })
    })
    .catch(error => {
      this.setState({ loading: false });
      console.log(error)
    })
  }

  render() {
    const { data, loading } = this.state
    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation/>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col w-full py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}}>{data.title && data.title.rendered}</div>
              </div>
              <Title level="1" className="underlined">{data.title && data.title.rendered}</Title>
              <div className={`page-content text-xs md:text-sm lg:text-base text-gray-500 leading-loose`} dangerouslySetInnerHTML={{__html: data.content && data.content.rendered }}/>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
